import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import Controller from '@ember/controller';
type View = 'card' | 'string';

export default class ProductViewControlController extends Controller {
  queryParams = ['view'];

  @tracked view: View = 'card';

  @action
  setView(e: View) {
    this.view = e;
  }
}
